// This file contains the list of mat options available for /justframe flow. Each mat option has an id, name, thickness, price, and image URL.
const matOptions = [
    {
        id: 'Real White HW6007 Max size: 100x150 cm',
        name: 'Real White HW6007 Max size: 100x150 cm',
        thickness: 20,
        price: 11.5,
        img: '/assets/CanvasMats/Real White HW6007 Max size 100x150 cm.jpg'
    },
    {
        id: 'China White HW6004 Max size: 100x150 cm',
        name: 'China White HW6004 Max size: 100x150 cm',
        thickness: 30,
        price: 11.5,
        img: '/assets/CanvasMats/China White HW6004 Max size 100x150 cm.jpg'
    },
    {
        id: 'Creamy White HW6008 Max size: 100x150 cm',
        name: 'Creamy White HW6008 Max size: 100x150 cm',
        thickness: 40,
        price: 11.5,
        img: '/assets/CanvasMats/Creamy White HW6008 Max size 100x150 cm.jpg'
    },
    {
        id: 'Old White HWG66002 Max size: 100x150 cm',
        name: 'Old White HWG66002 Max size: 100x150 cm',
        thickness: 50,
        price: 20.95,
        img: '/assets/CanvasMats/Old White HWG66002 Max size 100x150 cm.jpg'
    },
    {
        id: 'Sand Stone HW6005 Max size: 80x100 cm',
        name: 'Sand Stone HW6005 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Sand Stone HW6005 Max size 80x100 cm.jpg'
    },
    {
        id: 'Black HW6100 Max size: 100x150 cm',
        name: 'Black HW6100 Max size: 100x150 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Black HW6100 Max size 100x150 cm.jpg'
    },
    {
        id: 'Grey Sage HW6304 Max size: 80x100 cm',
        name: 'Grey Sage HW6304 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Grey Sage HW6304 Max size 80x100 cm.jpg'
    },
    {
        id: 'Gold HWG66700 Max size: 100x150 cm',
        name: 'Gold HWG66700 Max size: 100x150 cm',
        thickness: 50,
        price: 23.9,
        img: '/assets/CanvasMats/Gold HWG66700 Max size 100x150 cm.jpg'
    },
    {
        id: 'Red Fire HW6502 Max size: 80x100 cm',
        name: 'Red Fire HW6502 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Red Fire HW6502 Max size 80x100 cm.jpg'
    },
    {
        id: 'Navy Blue HW6200 Max size: 80x100 cm',
        name: 'Navy Blue HW6200 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Navy Blue HW6200 Max size 80x100 cm.jpg'
    },
    {
        id: 'Royal Blue HW6203 Max size: 80x100 cm',
        name: 'Royal Blue HW6203 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Royal Blue HW6203 Max size 80x100 cm.jpg'
    },
    {
        id: 'Yellow Sun HW6601 Max size: 80x100 cm',
        name: 'Yellow Sun HW6601 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Yellow Sun HW6601 Max size 80x100 cm.jpg'
    },
    {
        id: 'Green Cricket HW6302 Max size: 80x100 cm',
        name: 'Green Cricket HW6302 Max size: 80x100 cm',
        thickness: 50,
        price: 11.5,
        img: '/assets/CanvasMats/Green Cricket HW6302 Max size 80x100 cm.jpg'
    },
];

export default matOptions;